import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import { ResearchInsightPopupComponent } from "../../mex-grid-page/research-insight-popup/research-insight-popup.component";
import { MexGridPageDataService } from "src/app/mex-grid-page/mex-grid-page-data.service";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { NzConfigService } from "ng-zorro-antd/core/config";
import { VAIconRegistryService } from "@va/core-library/icons";
import { PharmaDataService } from "../pharma-data.service";

@Component({
  selector: "app-pharma-research-insight-popup",
  templateUrl: "./pharma-research-insight-popup.component.html",
  styleUrls: ["./pharma-research-insight-popup.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PharmaResearchInsightPopupComponent extends ResearchInsightPopupComponent {
  @Input() ticker = "";
  @Input() dapParamObj: any = null;
  @Input() showPopup = false;
  @Output() closePopup = new EventEmitter();

  constructor(
    protected mexService: MexGridPageDataService,
    protected notification: NzNotificationService,
    protected nzConfigService: NzConfigService,
    protected iconRegistry: VAIconRegistryService,
    protected phamaService: PharmaDataService,
  ) {
    super(mexService, notification, nzConfigService, iconRegistry);
    //this.selectDocumentclick = this.selectPharmaDocument
  }

  ngOnInit() {
    this.maskObj = {
      opacity: 0,
      "background-color": "transparent",
    };
    this.pageSize = 15;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showPopup && changes.showPopup.currentValue === true) {
      this.documentsList = [];
      this.pageNo = 0;
      this.sentencesList = [];
      this.loading = true;
      this.loadingSentences = true;
      this.currentDocument = null;
      this.currentDocumentLink = "";
      this.totalReports = 0;
      this.lineItemName = "";
      this.getDocumentData();
    }
  }

  @HostListener("window:resize", [])
  sizeResearchChange() {
    const windowSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
    this.styleObj = {
      height: `${windowSize.height - 85}px`, //header height
    };
  }

  public getDocumentData() {
    const payload = {
      drugid: this.dapParamObj.drugid,
      parameterid: this.dapParamObj.parameterid,
      brokers: this.dapParamObj.brokers,
    };
    this.phamaService.getPharmaDSMDrugDocument(payload).subscribe(
      (resp: any) => {
        if (resp.status === "success") {
          this.documentsList.push(...resp.data.documents);
          this.loading = false;
          if (this.pageNo === 0) {
            this.totalReports = resp.data.total_document_count;
            this.lineItemName = resp.data.dapparametername;
            this.selectDocument(this.documentsList[0]);
          }
        } else {
          this.notification.error(
            this.title,
            "Something went wrong while fetching data. Please try again later!",
          );
          this.loading = false;
        }
      },
      (err) => {
        this.loading = false;
        this.notification.error(
          this.title,
          `Something went wrong while fetching data. Please try again later!${err}`,
        );
      },
    );
  }

  selectDocument(doc) {
    this.currentDocument = { ...doc };
    this.currentDocumentLink = doc.document_url;
    this.sentencesList = [];
    this.getSentenceData();
  }

  getSentenceData() {
    this.loadingSentences = true;
    const params = {
      drugid: this.dapParamObj.drugid,
      parameterid: this.dapParamObj.parameterid,
      documentid: this.currentDocument.document_id,
    };
    this.phamaService.getPharmaDSMDocumentSentences(params).subscribe(
      (resp: any) => {
        if (resp.status === "success") {
          this.sentencesList = resp.data.sentences.map((val) => {
            const option =
              val.last_user_selection === 1
                ? "Yes"
                : val.last_user_selection === 2
                  ? "No"
                  : "";
            val["showClear"] = option !== "";
            val["optionSelected"] = option;
            return val;
          });
          this.loadingSentences = false;
          this.sentencesList.forEach((item) => {
            item["isExpand"] = true;
            item["org_sentence_text"] = item.sentence_text;
            let index = 0;
            let newHtmlSentence = "";
            const wordArr = [];
            const reasearchText = item.sentence_text;
            item["highlights"].forEach(function (pos) {
              if (
                reasearchText.length > pos[0] &&
                reasearchText.length >= pos[1]
              ) {
                wordArr.push(reasearchText.substring(index, pos[0]));
                wordArr.push(
                  `<span class='highlights-text'>${reasearchText.substring(
                    pos[0],
                    pos[1],
                  )}</span>`,
                );
                index = pos[1];
              }
            });
            wordArr.push(reasearchText.substring(index));
            wordArr.forEach(function (item) {
              newHtmlSentence = newHtmlSentence + item;
            });
            if (newHtmlSentence !== "") {
              item.sentence_text = newHtmlSentence;
            }
          });
        } else {
          this.notification.error(
            this.title,
            "Something went wrong while fetching data. Please try again later!",
          );
          this.loadingSentences = false;
        }
      },
      (err) => {
        this.notification.error(
          this.title,
          `Something went wrong while fetching data. Please try again later!${err}`,
        );
        this.loadingSentences = false;
      },
    );
  }

  setUserSelection(obj) {
    let userSelection = 0;
    if (obj.optionSelected === "Yes") {
      userSelection = 1;
    }
    if (obj.optionSelected === "No") {
      userSelection = 2;
    }
    if (obj.optionSelected === "") {
      userSelection = 3;
    }
    const payload = {
      associationid: obj.sentencepredictionsidentifier,
      dapparameterid: this.dapParamObj.dapparameterid,
      sentence_rank: obj.sentence_rank,
      usercomments: "",
      userchoice: userSelection,
    };
    this.phamaService
      .setUserSelectionForDSMDocumentSentences(payload)
      .subscribe((resp: any) => {
        if (resp.status === "success")
          this.notification.success(this.title, "User selection saved!");
        else
          this.notification.error(
            this.title,
            "Something went wrong while saving your response. Please try again later!",
          );
      });
  }

  ExpandContent(i) {
    this.sentencesList[i].isExpand = true;
  }
  CollapsContent(i) {
    this.sentencesList[i].isExpand = false;
  }
}
